export enum NotificationTypeEnum {
	Old = 'old',
	New = 'new'
}

export const NOTIFICATION_TABLE_CELL = [
	{ title: '', style: { width: '1%' }, sortable: false, key: '#', type: '' },
	{ title: 'ID', style: { width: '1%' }, sortable: false, key: 'id', type: '' },
	{ title: 'Category Name', style: { width: '3%' }, sortable: true, key: 'category_name', type: '' },
	{ title: 'Status', style: { width: '10%' }, sortable: true, key: 'status', type: '' },
	{ title: 'Requested By', style: { width: '4%' }, sortable: false, key: 'requested_by', type: '' },
	{ title: '', style: { width: '1%' }, sortable: false, key: '', type: '' }
];

export const PRIORITY_DROPDOWN = [
	{ label: 'Normal', value: 'Normal' },
	{ label: 'Medium', value: 'Medium' },
	{ label: 'High', value: 'High' }
];

export const INIT_PAGINATION = {
	currentPage: 1,
	nextPage: 0,
	perPage: 10,
	remainingCount: 0,
	total: 0,
	totalPages: null
};

export const INIT_PER_PAGE = 10;

export const ALLOW_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/jpg'];

export const PASSWORD_VALIDATOR_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[_\W])(?!.*\s).{8,25}$/;
export const NUMBER_REGEX = /^[0-9]+(?:\.[0-9]+)?$/;

export const IBAN_REGEX = /^DE\d{20}$/;

export const ERROR_CODE = [500, 501, 502, 503, 504, 505, 506, 507, 508, 510, 511];

export const FREE_PRIZE_ID = 'ca6a2e93-e7bf-402d-9515-5249de0dd615';
